export const areElementsIntersecting = (elementOne: HTMLElement, elementTwo: HTMLElement): boolean => {
    const elementOneRect = elementOne.getBoundingClientRect();
    const elementTwoRect = elementTwo.getBoundingClientRect();
    const noIntersection =
        elementOneRect.right <= elementTwoRect.left ||
        elementOneRect.left >= elementTwoRect.right ||
        elementOneRect.bottom <= elementTwoRect.top ||
        elementOneRect.top >= elementTwoRect.bottom;

    return !noIntersection;
};

export const isTouchEvent = (event: React.MouseEvent | React.TouchEvent): boolean => {
    return event?.type?.includes("touch");
};

/**
 * Returns an onKeyDown handler that activates `callback` when the user presses
 * Enter or Space, mirroring native button behaviour. Use this to make custom
 * (non-button) interactive elements operable for keyboard and screen-reader users.
 */
export const handleKeyboardActivation =
    (callback?: (event: React.KeyboardEvent) => void) =>
    (event: React.KeyboardEvent): void => {
        if (!callback) return;

        if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
            // Prevent Space from scrolling the page and Enter from any default submit.
            event.preventDefault();
            callback(event);
        }
    };
